import { createElement, type ComponentType } from "react";

type DefaultComponentModule<Props extends object> = {
    default: ComponentType<Props>;
};

export function lazyRoute<Props extends object>(
    load: () => Promise<DefaultComponentModule<Props>>,
    ...propsArgument: object extends Props ? [props?: Props] : {} extends Props ? [props?: Props] : [props: Props]
) {
    return async () => {
        const Page = (await load()).default;
        const props = (propsArgument[0] ?? {}) as Props;
        return {
            Component: () => createElement(Page, props),
        };
    };
}
